// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Functions
import { createAPINetworkInstance } from 'common/api';

// Types
import { ActionGetUrlUpgradeAPI, getUrlUpgradeAPIError, getUrlUpgradeAPISuccess, } from './actions';

function* getUrlUpgrade(action: ActionGetUrlUpgradeAPI) {
    try {
        const connection  = "DealerOn Upsell Redirect";
        const dealerId  = action.dealerId;
        const { data } = yield call(createAPINetworkInstance().get, `/urls/${connection}/dealer/${dealerId}`);
        yield put(getUrlUpgradeAPISuccess(data));
    } catch (err) {
        yield put(getUrlUpgradeAPIError(err));
    }
}

export default function* urlSagas() {
    yield takeLatest(ACTIONS.GET_URLUPGRADE_API_REQUEST, getUrlUpgrade);
}
